// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "3.81.2/styles/" + (chunkId === 225 ? "videojs" : chunkId) + ".chunk.css?" + {"225":"16fa5589237a9d2038b6","753":"353faa143a2edd9cbb97"}[chunkId] + "";
};